export const uefaSeries: Array<{label: string, value: string, tags: Array<{ tag: string, date: Date }>}> = [
  { label: 'Play-Off', value: 'play-off', tags: [
    { tag: 'bajnokok-ligaja-play-off', date: new Date('2025-08-12') }
  ] },
  { label: '1. forduló', value: '1-fordulo', tags: [
    { tag: 'bajnokok-ligaja-1-fordulo', date: new Date('2025-09-16') }
  ] },
  { label: '2. forduló', value: '2-fordulo', tags: [
    { tag: 'bajnokok-ligaja-2-fordulo', date: new Date('2025-09-30') }
  ] },
  { label: '3. forduló', value: '3-fordulo', tags: [
    { tag: 'bajnokok-ligaja-3-fordulo', date: new Date('2025-10-21') }
  ] },
  { label: '4. forduló', value: '4-fordulo', tags: [
    { tag: 'bajnokok-ligaja-4-fordulo', date: new Date('2025-11-04') }
  ] },
  { label: '5. forduló', value: '5-fordulo', tags: [
    { tag: 'bajnokok-ligaja-5-fordulo', date: new Date('2025-11-25') }
  ] },
  { label: '6. forduló', value: '6-fordulo', tags: [
    { tag: 'bajnokok-ligaja-6-fordulo', date: new Date('2025-12-09') }
  ] },
  { label: '7. forduló', value: '7-fordulo', tags: [
    { tag: 'bajnokok-ligaja-7-fordulo', date: new Date('2026-01-20') }
  ] },
  { label: '8. forduló', value: '8-fordulo', tags: [
    { tag: 'bajnokok-ligaja-8-fordulo', date: new Date('2026-01-28') }
  ] },
  { label: 'Rájátszás', value: 'rajatszas', tags: [
    { tag: 'bajnokok-ligaja-rajatszas-odavago', date: new Date('2026-02-17') },
    { tag: 'bajnokok-ligaja-rajatszas-visszavago', date: new Date('2026-02-24') }
  ] },
  { label: 'Nyolcaddöntő', value: 'nyolcaddonto', tags: [
    { tag: 'bajnokok-ligaja-nyolcaddonto-odavago', date: new Date('2026-03-10') },
    { tag: 'bajnokok-ligaja-nyolcaddonto-visszavago', date: new Date('2026-03-17') }
  ] },
  { label: 'Negyeddöntő', value: 'negyeddonto', tags: [
    { tag: 'bajnokok-ligaja-negyeddonto-odavago', date: new Date('2026-04-07') },
    { tag: 'bajnokok-ligaja-negyeddonto-visszavago', date: new Date('2026-04-14') }
  ] },
  { label: 'Elődöntő', value: 'elodonto', tags: [
    { tag: 'bajnokok-ligaja-elodonto-odavago', date: new Date('2026-04-28') },
    { tag: 'bajnokok-ligaja-elodonto-visszavago', date: new Date('2026-05-05') }
  ] },
  { label: 'Döntő', value: 'donto', tags: [
    { tag: 'bajnokok-ligaja-donto', date: new Date('2026-05-30') }
  ] }
]
